import {NgModule} from "@angular/core";
import {RouterModule, Routes} from "@angular/router";
import {PURLPageComponent} from "./components/purlpage/purlpage.component";
import {PurlPageSettingsResponseResolver} from "./resolvers/purl-page-settings-response.resolver";
import {environment} from "../../../environments/environment";
import {PageNotFoundComponent} from "fello-common";

const routes: Routes = [
  {
    path: ":purlId",
    pathMatch: "full",
    component: PURLPageComponent,
    resolve: {
      settings: PurlPageSettingsResponseResolver
    },
    data: {
      enableSubdomainFixing: environment.enableSubdomainFixing
    }
  },
  {
    path: ":purlId/:landingPageConfigId",
    component: PURLPageComponent,
    resolve: {
      settings: PurlPageSettingsResponseResolver
    },
    data: {
      enableSubdomainFixing: environment.enableSubdomainFixing
    }
  },
  {
    path: "**",
    component: PageNotFoundComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PurlRoutingModule {}
